<template>
  <CToaster :autohide="3000" :closeButton="false" position="top-center" class="Toaster" v-if="$store.state.toastMessage">
    <template v-for="(toast, i) in $store.state.toastMessage">
      <CToast :key="`${toast}-${i}`" :show="true">
        <template #header>
          <i class="icon fas fa-exclamation text-white bg-primary exclamation mr-2"></i>
          <p class="text-primary font-base m-0">
            {{ toast.title }}
          </p>
        </template>
        <template #default>
          <p class="pr-5">
            {{ toast.text }}
          </p>
        </template>
      </CToast>
    </template>
  </CToaster>
</template>

<script>
export default {
  name: 'ToastMessage',
  data() {
    return {
      toastMessage: '',
    }
  },
  mounted() {
    this.toastMessage = this.$store.state.toastMessage
  },
  updated() {
    this.toastMessage = []
  },
}
</script>

<style></style>
